import {ID} from "@datorama/akita";

export function idToNumber(id: ID): number {
    return typeof id === "string" ? parseInt(id) : id
}